var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0013 0.666656C15.668 0.666656 0.667969 15.6667 0.667969 34C0.667969 52.3333 15.668 67.3333 34.0013 67.3333C52.3346 67.3333 67.3346 52.3333 67.3346 34C67.3346 15.6667 52.3346 0.666656 34.0013 0.666656ZM45.8346 46.6667L32.2346 38.3C31.2346 37.7 30.6346 36.6333 30.6346 35.4667V19.8333C30.668 18.4667 31.8013 17.3333 33.168 17.3333C34.5346 17.3333 35.668 18.4667 35.668 19.8333V34.6667L48.468 42.3667C49.668 43.1 50.068 44.6667 49.3346 45.8667C48.6013 47.0333 47.0346 47.4 45.8346 46.6667Z",
    fill: "#7E7892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.b5f965486a38678f1e5ea674f4f7c3a1.svg";
export { ForwardRef as ReactComponent };